import STEP_DEFINITIONS from 'components/shared/OnboardingWizard/lib/stepDefinitions';
import SUBSTEP_DEFINITIONS from 'components/shared/OnboardingWizard/lib/substepDefinitions';

import Tags from '../components/Tags';
import Forms from '../components/Forms';
import Services from '../components/Services';
import Providers from '../components/Providers';
import FooterButtons from '../components/FooterButtons';
import NameAndAutomation from '../components/NameAndAutomation/NameAndAutomation';

// Per-breadcrumb view/footer map for the packet builder wizard modal.
export const buildActionViews = ({
  handleFormView,
  navigateToSubstep,
  providersList,
  servicesList,
  tagsList,
  formsList,
  formId
}) => ({
  name_and_automation: {
    component: (
      <NameAndAutomation
        currentBreadcrumb="name_and_automation"
        handleFormView={handleFormView}
        handleAddNewForm={() => {
          navigateToSubstep(
            SUBSTEP_DEFINITIONS[STEP_DEFINITIONS.CUSTOM_FORMS.code].CLINICAL_FORMS.code
          );
        }}
      />
    ),
    footer: <FooterButtons />
  },
  providers: {
    component: <Providers currentBreadcrumb="providers" providersList={providersList} />,
    footer: <FooterButtons nextTo={true} backTo={true} showNavigationButtons={true} />
  },
  services: {
    component: <Services currentBreadcrumb="services" servicesList={servicesList} />,
    footer: <FooterButtons nextTo={true} backTo={true} showNavigationButtons={true} />
  },
  tags: {
    component: <Tags currentBreadcrumb="tags" tagsList={tagsList} />,
    footer: <FooterButtons nextTo={true} backTo={true} showNavigationButtons={true} />
  },
  forms: {
    component: (
      <Forms
        currentBreadcrumb="forms"
        formsList={formsList}
        formId={formId}
        handleAddNewForm={() => {
          navigateToSubstep(
            SUBSTEP_DEFINITIONS[STEP_DEFINITIONS.CUSTOM_FORMS.code].CLINICAL_FORMS.code
          );
        }}
      />
    ),
    footer: <FooterButtons nextTo={true} backTo={true} showNavigationButtons={true} isLastStep />
  }
});
